import { Empty } from 'antd';

export const GENERAL_EMPTY_IMAGE = Empty.PRESENTED_IMAGE_SIMPLE;
